const _version = "3.0.4"
function version() {
    return _version
}
export default version
